
/*@ngInject*/
const ScrollFixedGridArrowDirective = function ($window, $timeout, submissionGridConstant) {

    let linkFunction = function ($scope, $elm) {

        let element = $($elm),
            gridWindow = element.parent(),
            toggleArrowOffset = 59,
            timerDelay = 1000,
            timeoutList = [];

        $scope.getWindowWidth = () => {
            return {'width': gridWindow.width()};
        };

        $scope.$watch($scope.getWindowWidth, (newValue) => {
            $scope.windowWidth = newValue.width;
            element.trigger('scroll');
        }, true);

        element.on('scroll', () => {
            let elementPositionX = $scope.windowWidth + element.scrollLeft() - toggleArrowOffset;
            element.find('.toggleDrawer').css('left', elementPositionX);
        });

        $scope.$on(submissionGridConstant.event.SUBMISSIONS_LOADED, function () {
            timeoutList.push($timeout(function () {
                element.trigger('scroll');
            }, timerDelay));
        });

        $scope.$on('$destroy', () => {
            element.off('scroll');
            _.each(timeoutList, (item) => {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('gw-um-submission-grid')
    .directive('scrollFixedGridArrow', ScrollFixedGridArrowDirective);
